import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { listEventCategoriesOptions } from '../../../features/event-categories/queries';
import { ExtractorConfigForm } from '../../../features/extractor-config/components/extractor-config-form';
import { extractorConfigOptions } from '../../../features/extractor-config/queries';
import { PageHeader } from '../../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/extractor-config/')({
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(extractorConfigOptions()),
      context.queryClient.ensureQueryData(listEventCategoriesOptions()),
    ]),
  component: ExtractorConfigPage,
});

function ExtractorConfigPage() {
  const { data: config } = useSuspenseQuery(extractorConfigOptions());
  const { data: categories } = useSuspenseQuery(listEventCategoriesOptions());
  return (
    <div>
      <PageHeader
        title="Парсер событий"
        description="Пороги и словари детерминированного экстрактора. Влияют на классификацию событие/дайджест и категории."
      />
      <ExtractorConfigForm config={config} categories={categories} />
    </div>
  );
}
